import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingStop, login } from 'redux/action';
import { toast } from 'react-toastify';
import { DashboardContainer, Table } from 'components';
import Body from './Body';
import API from 'services/api';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';

const Index = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [searchInput, setSearchInput] = useState('');
  const [searchBy, setSearchBy] = useState(state.search_by);
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const options = [
    { label: 'Upgrade', value: 'upgrade' },
    { label: 'Renewal', value: 'renewal' }
  ];

  useEffect(() => {
    init();
    // getActiveHsppStateLocationReport();
  }, [searchBy]);
  useEffect(() => {
    if (searchInput == '') {
      setTableData(originalData);
    } else {
      const filteredResults = originalData.filter((data) =>
        Object.values(data).join(', ').toLowerCase().includes(searchInput.toLowerCase())
      );
      setTableData(filteredResults);
    }
  }, [searchInput]);

  const init = () => {
    dispatch(loadingStart());
    API.getSubscriptionPlanChangeReport(searchBy.value)
      .then((response) => {
        if (response) {
          setTableData(response);
          setOriginalData(response);
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  return (
    <DashboardContainer>
      <Body
        _this={{
          init,
          tableData,
          searchInput,
          setSearchInput,
          options,
          searchBy,
          setSearchBy
        }}
      />
    </DashboardContainer>
  );
};

export default Index;
